module.exports = __webpack_public_path__ + "img/ic-route.c3367c36.svg";